/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-11-01 14:41:09
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-16 17:29:45
 */
import { request } from '@/utils/request'

const baseUrl = 'identity'
export default {
  upload(data) {
    return request({
      method: 'post',
      url: '/upload/user',
      data,
      formData: true,
      baseUrl
    })
  },
  uploadLogo(data) {
    return request({
      method: 'post',
      url: '/upload/public',
      data,
      formData: true,
      baseUrl
    })
  },
  setSystemSetting(data) {
    return request({
      method: 'post',
      url: '/system_settings',
      data,
      baseUrl
    })
  },
  getSystemSetting() {
    return request({
      method: 'get',
      url: '/system_settings',
      baseUrl
    })
  }
}
